/**
 * IntelliGems A/B Test: Installment price breakdown in Sticky ATC
 *
 * Controlled via BODY attribute:
 *   Control (A): document.body.setAttribute('data-sticky-atc-installments', 'false')
 *   Variant (B): document.body.setAttribute('data-sticky-atc-installments', 'true')
 *
 * Dev preview: ?sticky_atc_installments_test=b
 *
 * Amount comes from Afterpay square-placement (4 payments / every 2 weeks).
 */
(function () {
  'use strict';

  if (window.__stickyAtcInstallmentsABTestInit) return;
  window.__stickyAtcInstallmentsABTestInit = true;

  var BODY_ATTR = 'data-sticky-atc-installments';
  var ROOT_ATTR = 'data-sticky-atc-installments-root';
  var AFTERPAY_PAYMENTS = 4;
  var applying = false;
  var debounceTimer = null;
  var injectTimer = null;
  var pollTimer = null;
  var pollAttempts = 0;
  var variantActive = null;
  var config = null;
  var barObserver = null;
  var placementObserver = null;

  function isDevVariantB() {
    try {
      return new URLSearchParams(window.location.search).get('sticky_atc_installments_test') === 'b';
    } catch (e) {
      return false;
    }
  }

  function isTruthy(value) {
    if (value == null) return false;
    var normalized = String(value).trim().toLowerCase();
    return normalized === 'true' || normalized === '1' || normalized === 'yes';
  }

  function isVariantB() {
    if (isDevVariantB()) return true;

    var body = document.body;
    var html = document.documentElement;
    if (!body || !html) return false;

    return isTruthy(body.getAttribute(BODY_ATTR)) || isTruthy(html.getAttribute(BODY_ATTR));
  }

  function readConfig() {
    if (config) return config;

    var node = document.getElementById('sticky-atc-installments-ab-data');
    if (!node) return null;

    try {
      config = JSON.parse(node.textContent);
    } catch (e) {
      config = null;
    }

    return config;
  }

  function formatInstallmentMoney(cents, moneyFormat) {
    var amount = (Math.max(0, cents) / 100).toFixed(2);
    var amountWithComma = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var format = moneyFormat || '${{amount}}';

    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountWithComma.split('.')[0])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountWithComma.split('.')[0])
      .replace(/\{\{\s*amount\s*\}\}/g, amountWithComma);
  }

  function dollarsToCents(value) {
    var dollars = parseFloat(String(value).replace(/[^\d.]/g, ''));
    if (!isFinite(dollars) || dollars <= 0) return null;
    return Math.round(dollars * 100);
  }

  function parseMoneyFromText(text) {
    if (!text) return null;
    var match = String(text).replace(/\u00a0/g, ' ').match(/\$\s*([\d,]+(?:\.\d{1,2})?)/);
    if (!match) return null;
    return dollarsToCents(match[1]);
  }

  function findAfterpayPlacement() {
    return document.querySelector(
      'square-placement, afterpay-placement, [data-platform="shopify-snippet"]'
    );
  }

  function getInstallmentFromShadow(placement) {
    var root = placement.shadowRoot;
    if (!root) return null;

    var amountNode = root.querySelector('.payment-amount, .afterpay-main-text strong');
    if (amountNode) {
      var fromAmount = parseMoneyFromText(amountNode.textContent);
      if (fromAmount) return fromAmount;
    }

    var textNode = root.querySelector('.afterpay-main-text, .afterpay-paragraph');
    if (textNode) {
      return parseMoneyFromText(textNode.textContent);
    }

    return parseMoneyFromText(root.textContent);
  }

  function getAfterpayInstallmentCents() {
    var placement = findAfterpayPlacement();
    if (!placement) return null;

    var fromShadow = getInstallmentFromShadow(placement);
    if (fromShadow) return fromShadow;

    var total = parseFloat(placement.getAttribute('data-amount'));
    if (isFinite(total) && total > 0) {
      return Math.round((total / AFTERPAY_PAYMENTS) * 100);
    }

    return null;
  }

  function resolvePriceCents(host) {
    var cfg = readConfig();
    var selectedId = null;

    var urlMatch = window.location.search.match(/[?&]variant=(\d+)/);
    if (urlMatch) selectedId = urlMatch[1];

    var stickySelect = document.querySelector(
      '.zrx-sticky-atc-select, [class*="sticky-atc-select"] select, [class*="sticky-atc-select"]'
    );
    if (stickySelect && stickySelect.value) {
      selectedId = stickySelect.value;
    }

    if (cfg && selectedId && cfg.variants && cfg.variants[selectedId] != null) {
      return Number(cfg.variants[selectedId]);
    }

    if (host) {
      var clone = host.cloneNode(true);
      var installment = clone.querySelector('[' + ROOT_ATTR + ']');
      if (installment && installment.parentNode) installment.parentNode.removeChild(installment);
      var matches = (clone.textContent || '').match(/\$\s*[\d,]+(?:\.\d{1,2})?/g);
      if (matches && matches.length) {
        var stickyCents = dollarsToCents(matches[matches.length - 1]);
        if (stickyCents) return stickyCents;
      }
    }

    if (cfg && cfg.price != null) return Number(cfg.price);
    return null;
  }

  function findStickyBar() {
    return document.querySelector('.zrx-sticky-atc-bar, [class*="sticky-atc-bar"]');
  }

  function findPriceHost() {
    var bar = findStickyBar();
    var scope = bar || document;

    var wrappers = scope.querySelectorAll(
      '.zrx-sticky-atc-product-title-price-wrapper, [class*="sticky-atc-product-title-price"]'
    );

    for (var i = 0; i < wrappers.length; i++) {
      if (wrappers[i].getClientRects().length) return wrappers[i];
    }

    if (wrappers[0]) return wrappers[0];

    return scope.querySelector(
      '.zrx-sticky-atc-content-wrapper, [class*="sticky-atc-content-wrapper"]'
    );
  }

  function openAfterpayDialog() {
    var placement = findAfterpayPlacement();
    if (!placement) return;

    var root = placement.shadowRoot;
    var button = root && root.querySelector('.afterpay-logo, #logo-link, .afterpay-link, button');
    if (button && typeof button.click === 'function') {
      button.click();
      return;
    }

    if (typeof placement.click === 'function') placement.click();
  }

  function ensureNode(host) {
    if (!host) return null;

    var existingInHost = host.querySelector('[' + ROOT_ATTR + ']');
    if (existingInHost) return existingInHost;

    var orphans = document.querySelectorAll('[' + ROOT_ATTR + ']');
    for (var i = 0; i < orphans.length; i++) {
      if (!orphans[i].closest('.zrx-sticky-atc-bar, [class*="sticky-atc-bar"]')) {
        orphans[i].parentNode && orphans[i].parentNode.removeChild(orphans[i]);
      }
    }

    var el = document.createElement('button');
    el.type = 'button';
    el.setAttribute(ROOT_ATTR, 'true');
    el.className = 'sticky-atc-installments-ab';
    el.setAttribute('aria-label', 'Afterpay installment details');
    el.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      openAfterpayDialog();
    });

    host.appendChild(el);
    return el;
  }

  function updateCopy(host, installmentCents) {
    var cfg = readConfig() || {};
    var node = ensureNode(host);
    if (!node) return false;

    if (!installmentCents) {
      node.hidden = true;
      return false;
    }

    var money = formatInstallmentMoney(installmentCents, cfg.moneyFormat);
    node.innerHTML =
      '<span class="sticky-atc-installments-ab__text">' +
        '<span class="sticky-atc-installments-ab__prefix">or as low as </span>' +
        '<span class="sticky-atc-installments-ab__amount">' + money + '</span>' +
        '<span class="sticky-atc-installments-ab__star"> *</span>' +
      '</span>';
    node.hidden = false;
    return true;
  }

  function syncInstallment() {
    if (!isVariantB()) {
      document.documentElement.classList.remove('sticky-atc-installments-b');
      var nodes = document.querySelectorAll('[' + ROOT_ATTR + ']');
      for (var i = 0; i < nodes.length; i++) nodes[i].hidden = true;
      return false;
    }

    document.documentElement.classList.add('sticky-atc-installments-b');

    var host = findPriceHost();
    if (!host) return false;

    var installmentCents = getAfterpayInstallmentCents();
    if (!installmentCents) {
      var priceCents = resolvePriceCents(host);
      if (priceCents) installmentCents = Math.round(priceCents / AFTERPAY_PAYMENTS);
    }

    if (!installmentCents) return false;

    observePlacement();
    return updateCopy(host, installmentCents);
  }

  function scheduleInject() {
    if (injectTimer) clearTimeout(injectTimer);
    injectTimer = setTimeout(function () {
      syncInstallment();
    }, 50);
  }

  function startPolling() {
    if (pollTimer) clearTimeout(pollTimer);
    pollAttempts = 0;

    function tick() {
      if (!isVariantB()) return;

      var ok = syncInstallment();
      pollAttempts += 1;

      if (pollAttempts < 40) {
        pollTimer = setTimeout(tick, ok && getAfterpayInstallmentCents() ? 1500 : 250);
      }
    }

    tick();
  }

  function observePlacement() {
    var placement = findAfterpayPlacement();
    if (!placement || !window.MutationObserver) return;

    if (placementObserver) placementObserver.disconnect();

    placementObserver = new MutationObserver(scheduleInject);
    placementObserver.observe(placement, {
      attributes: true,
      attributeFilter: ['data-amount']
    });

    if (placement.shadowRoot) {
      placementObserver.observe(placement.shadowRoot, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  }

  function observeStickyBar() {
    if (barObserver || !window.MutationObserver) return;

    barObserver = new MutationObserver(function () {
      if (!isVariantB()) return;
      scheduleInject();
    });

    barObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function applyVariant() {
    if (applying) return;
    applying = true;

    try {
      var variantB = isVariantB();

      if (variantB === variantActive) {
        if (variantB) scheduleInject();
        return;
      }

      variantActive = variantB;
      document.documentElement.classList.toggle('sticky-atc-installments-b', variantB);

      if (variantB) {
        observeStickyBar();
        startPolling();
      } else {
        syncInstallment();
      }
    } finally {
      applying = false;
    }
  }

  function scheduleApply() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(applyVariant, 40);
  }

  function observeRoot(root) {
    if (!root || !window.MutationObserver) return;

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === BODY_ATTR ||
          mutations[i].attributeName === 'data-gem-variant' ||
          mutations[i].attributeName === 'data-gem-test-active') {
          scheduleApply();
          return;
        }
      }
    }).observe(root, {
      attributes: true,
      attributeFilter: [BODY_ATTR, 'data-gem-variant', 'data-gem-test-active']
    });
  }

  function init() {
    var isProduct =
      document.body &&
      (document.body.classList.contains('template-product') ||
        document.getElementById('sticky-atc-installments-ab-data') ||
        /\/products\//.test(window.location.pathname));

    if (!isProduct) return;

    if (isDevVariantB()) {
      if (document.documentElement.getAttribute(BODY_ATTR) !== 'true') {
        document.documentElement.setAttribute(BODY_ATTR, 'true');
      }
      if (document.body && document.body.getAttribute(BODY_ATTR) !== 'true') {
        document.body.setAttribute(BODY_ATTR, 'true');
      }
    }

    applyVariant();

    observeRoot(document.documentElement);
    observeRoot(document.body);

    document.addEventListener('gem:variant:changed', scheduleApply);
    document.addEventListener('change', function (event) {
      if (!event.target) return;
      if (
        event.target.matches(
          '.zrx-sticky-atc-select, [class*="sticky-atc-select"], [name="id"], select[name="id"]'
        )
      ) {
        scheduleInject();
      }
    });
    document.addEventListener('variant:changed', scheduleInject);
    document.addEventListener('product:variant-change', scheduleInject);
    window.addEventListener('popstate', scheduleInject);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
